import * as NavConstants from 'constants/NavConstants';
import {_editorBase} from 'foundation/EditorRoutes';
import * as AISidepanel from 'llm/chat-library/sidepanel/AISidepanel';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import DatadogUtil from 'performance/DatadogUtil';
import {RouteBundle} from 'routing/RouteConstants';

export const AIRoutes: RouteBundle = {
  domain: 'llm',
  routes: [
    {
      urlPattern: 'chats/new',
      handler: () => {
        DatadogUtil.startRUMView('chats_new');
        AISidepanel.openNewChat();
        _editorBase(() => {
          SidepanelActions.expandSection(NavConstants.SECTIONS.AI);
        });
      },
    },
    {
      urlPattern: 'chats/:id',
      handler: (chatSessionId: string) => {
        DatadogUtil.startRUMView('chats_existing');
        AISidepanel.openExistingChat(chatSessionId);
        _editorBase(() => {
          SidepanelActions.expandSection(NavConstants.SECTIONS.AI);
        });
      },
    },
  ],
};
